import { Link } from "react-router-dom";
import BlogPostLayout from "./BlogPostLayout";
import { getPostBySlug } from "../../lib/blog";

export default function GuepeVsFrelon() {
  const post = getPostBySlug("difference-guepe-frelon-frelon-asiatique");
  return (
    <BlogPostLayout post={post}>
      <p>
        « Est-ce une guêpe ou un frelon asiatique ? » Cette question, nous la
        recevons chaque semaine en Creuse. La confusion est fréquente et peut
        entraîner soit une intervention inutile, soit au contraire, laisser
        prospérer un nid dangereux. Voici comment{" "}
        <strong>distinguer avec certitude</strong> les 3 espèces qui piquent
        et prendre la bonne décision.
      </p>

      <h2>Comparatif rapide des 3 espèces</h2>
      <table>
        <thead>
          <tr>
            <th>Critère</th>
            <th>Guêpe commune</th>
            <th>Frelon européen</th>
            <th>Frelon asiatique</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Taille</td>
            <td>10-15 mm</td>
            <td>20-35 mm</td>
            <td>17-32 mm</td>
          </tr>
          <tr>
            <td>Couleur</td>
            <td>Jaune vif + noir</td>
            <td>Jaune + brun-rouge</td>
            <td>Sombre, pattes jaunes</td>
          </tr>
          <tr>
            <td>Nid</td>
            <td>Ovoïde, sous toit ou sol</td>
            <td>Bas, creux d'arbre / cheminée</td>
            <td>Sphérique, arbres hauts</td>
          </tr>
          <tr>
            <td>Agressivité</td>
            <td>Élevée si dérangée</td>
            <td>Modérée</td>
            <td>Forte, défense collective</td>
          </tr>
          <tr>
            <td>Dangerosité</td>
            <td>Modérée</td>
            <td>Modérée à forte</td>
            <td>Forte (piqûres multiples)</td>
          </tr>
        </tbody>
      </table>

      <h2>Reconnaître la guêpe commune</h2>
      <p>
        La <strong>guêpe commune (Vespula vulgaris)</strong> est la plus
        petite des trois. Corps <strong>très jaune, rayures noires nettes</strong>.
        Elle mesure 10-15 mm et présente une "taille" (rétrécissement)
        marqué. Elle est très attirée par les aliments sucrés et les grillades
        en fin d'été. Son nid est ovoïde, gris clair, souvent construit sous
        les toits, dans les greniers ou dans le sol.
      </p>
      <p>
        <strong>Danger</strong> : piqûre douloureuse, allergie possible.
        Rarement mortelle sauf réaction anaphylactique. Un nid contient
        1 000-2 000 individus en fin de saison.
      </p>

      <h2>Reconnaître le frelon européen</h2>
      <p>
        Le <strong>frelon européen (Vespa crabro)</strong> est le plus gros
        des trois (jusqu'à 3,5 cm). Il est <strong>jaune et brun-rouge</strong>,
        avec un thorax roussâtre distinctif. Contrairement à sa réputation, il
        est <strong>peu agressif</strong> tant qu'on ne l'approche pas de son
        nid. Il chasse d'autres insectes (mouches, guêpes, chenilles).
      </p>
      <p>
        Son nid, plutôt bas (creux d'arbre, cheminée, grenier), a une entrée{" "}
        <strong>par le bas</strong>. C'est une espèce protégée en Allemagne
        et menacée dans plusieurs régions : à ne détruire que si le nid
        présente un vrai danger pour les habitants.
      </p>

      <h2>Reconnaître le frelon asiatique (Vespa velutina)</h2>
      <p>
        Le <strong>frelon asiatique</strong> est celui qui inquiète le plus en
        Creuse. Introduit en France en 2004, il a colonisé tout le territoire
        et représente aujourd'hui la menace n°1 pour les abeilles. Il mesure
        17-32 mm, <strong>plus sombre</strong> que ses cousins (abdomen
        presque noir avec un anneau jaune orangé), et se distingue surtout par
        ses <strong>pattes jaunes vif</strong>.
      </p>

      <div className="callout">
        <strong>Signe distinctif clé</strong>
        Le frelon asiatique a les <strong>pattes jaunes vif</strong> (comme
        trempées dans la peinture jaune). Le frelon européen a les pattes
        brunes. C'est le critère le plus fiable à distance.
      </div>

      <p>
        Son nid est <strong>sphérique</strong> (comme un ballon de 30-80 cm),
        <strong> perché haut</strong> (souvent {'>'}  8 m) dans un arbre
        feuillu, avec une <strong>ouverture latérale</strong> (jamais par le
        bas). C'est un critère infaillible : si l'entrée est en bas, ce n'est
        PAS un frelon asiatique.
      </p>

      <p>
        <strong>Danger</strong> : forte agressivité en défense du nid,
        piqûres multiples (jusqu'à 40 en quelques secondes en essaim), risque
        d'anaphylaxie chez les personnes allergiques. Chaque année, plusieurs
        décès en France sont attribués aux attaques de frelons asiatiques.
        Consultez notre guide{" "}
        <Link to="/conseils/reconnaitre-nid-frelons-asiatiques-creuse">
          Comment reconnaître un nid de frelons asiatiques
        </Link>.
      </p>

      <h2>Vous avez repéré un individu : que faire ?</h2>
      <ul>
        <li>
          <strong>Un individu isolé</strong> — pas d'urgence. Observez sans
          approcher, prenez une photo (zoom depuis 5 m minimum).
        </li>
        <li>
          <strong>Plusieurs individus en va-et-vient</strong> — signe qu'un
          nid est à proximité (moins de 500 m). À signaler.
        </li>
        <li>
          <strong>Un nid visible</strong> — <strong>NE PAS S'APPROCHER</strong>.
          Contactez un professionnel Certibiocide. Voir notre page{" "}
          <Link to="/destruction-frelons-creuse">
            destruction de nids de frelons en Creuse
          </Link>.
        </li>
      </ul>

      <div className="callout-warn">
        <strong>Ne détruisez jamais un nid vous-même</strong>
        Une simple vibration (échelle, souffleur, tondeuse) peut déclencher
        une attaque massive. Les piqûres multiples peuvent provoquer un choc
        anaphylactique, y compris chez des personnes non allergiques. C'est
        un travail de professionnel équipé.
      </div>

      <h2>Combien ça coûte ?</h2>
      <ul>
        <li>Nid de guêpes accessible (jusqu'à 4 m) : <strong>90-130 €</strong></li>
        <li>Nid de frelons européens : <strong>110-160 €</strong></li>
        <li>Nid de frelons asiatiques (perche télescopique) : <strong>130-220 €</strong></li>
        <li>Nid haut ({'>'}  15 m, nacelle nécessaire) : <strong>250-400 €</strong></li>
      </ul>

      <h2>Pour aller plus loin</h2>
      <p>
        Consultez notre article{" "}
        <Link to="/conseils/frelons-asiatiques-creuse-que-faire">
          Frelons asiatiques en Creuse : que faire ?
        </Link>{" "}
        et notre page complète{" "}
        <Link to="/entreprise-nuisibles-creuse">
          entreprise anti-nuisibles Creuse
        </Link>.
      </p>
    </BlogPostLayout>
  );
}
